import { render, staticRenderFns } from "./ChampionshipNavigation.vue?vue&type=template&id=5fe0e51e&scoped=true&"
import script from "./ChampionshipNavigation.vue?vue&type=script&lang=js&"
export * from "./ChampionshipNavigation.vue?vue&type=script&lang=js&"
import style0 from "./ChampionshipNavigation.vue?vue&type=style&index=0&id=5fe0e51e&lang=scss&scoped=true&"
import style1 from "./ChampionshipNavigation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe0e51e",
  null
  
)

export default component.exports